module.exports = __webpack_public_path__ + "static/12-870f8d47eb13bfba97ce1c7acc5109f2.jpg";